import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './spinner/spinner.component'; // Import SpinnerComponent
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    SpinnerComponent,
  ],
  imports: [
    CommonModule,
    DialogModule,
    ProgressSpinnerModule
  ],
  exports: [
    SpinnerComponent,
  ]
})
export class SharedModule { }
